import React from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import StatusIcon from "./StatusIcon";
import { colors } from "../../theme";

interface OwnMessageCardProps {
  text?: string;
  timestamp?: string;
  status?: {
    delivery_status?: string;
    error_message?: string;
    raw?: any;
  } | null;
}

const OwnMessageCard = ({ text, timestamp, status }: OwnMessageCardProps) => {
  // Extract delivery status and error message, supporting multiple field names
  const deliveryStatus = status?.delivery_status || (status?.raw && (status.raw.delivery_status || status.raw.status));
  let errorMessage: string | undefined;
  errorMessage = status?.error_message || (status?.raw && (status.raw.error_message || status.raw.errorMessage));
  return (
    <Paper
      sx={{
        background: colors.green1,
        display: "flex",
        maxWidth: "70%",
        textAlign: "start",
        padding: ".35rem .8rem",
        flexDirection: "column",
        borderRadius: ".625rem",
        position: "relative",
        "&::after": {
          content: '" "',
          border: "20px solid transparent",
          position: "absolute",
          top: 0,
          right: "-1.25rem",
          borderTopRightRadius: ".5rem",
          borderTopColor: colors.green1,
        },
      }}
    >
      <Typography
        color={colors.white1}
        sx={{
          fontSize: "1rem",
        }}
      >
        {text || ""}
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          alignSelf: "flex-end",
          marginTop: "0.25rem",
          gap: "0.25rem",
        }}
      >
        <Typography
          color={colors.grey1}
          sx={{
            fontSize: ".85rem",
          }}
        >
          {timestamp || ""}
        </Typography>
        <StatusIcon delivery_status={deliveryStatus} error_message={errorMessage} />
      </Box>
    </Paper>
  );
};

export default OwnMessageCard;
